<template>
    <StoryblokPageContainer v-if="story" :story="story" />
</template>

<script setup lang="ts">
import StoryblokPageContainer from '~/components/page-building/StoryblokPageContainer.vue';
import { sendDataLayerPageView } from '~/composables/useDataLayer';
import useStoryblokSeoData from '~/composables/useStoryblokSeoData';

const { story, initBridge } = await useStoryblokStory({
    folder: 'blog/category',
});

useStoryblokSeoData(story.value);

onMounted(() => {
    sendDataLayerPageView();
    initBridge();
});
</script>
